import { SchemaError } from './SchemaError'

/**
 * ADT Schema 警告
 */
export abstract class SchemaWarning extends SchemaError {}
